import { getEnvDefault } from '@main/core-ui';

/** Provided by jest */
const JEST_WORKER_ID = getEnvDefault(
  'JEST_WORKER_ID',
  '___JEST_WORKER_ID___',
  'undefined',
);

/**
 * Whether or not the penumbra API should be mocked
 */
export const SHOULD_MOCK_PENUMBRA =
  getEnvDefault(
    'SHOULD_MOCK_PENUMBRA',
    '___SHOULD_MOCK_PENUMBRA___',
    'false',
  ) === 'true' || JEST_WORKER_ID !== 'undefined';
